export var initialState = {
    returnToLoginError: null,
    lockedAccountUsername: null,
};
